import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-imprint',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './imprint.component.html',
  styleUrls: ['./imprint.component.scss']
})
export class ImprintComponent {
  // Firmendaten - diese sollten später ggf. aus einer Konfiguration geladen werden
  companyInfo = {
    name: 'Videowand Leipzig Inhaber Jan Waschke',
    street: 'Nikolaus-Lenau-Str. 15',
    zip: '04425',
    city: 'Taucha',
    country: 'Deutschland',
    phone: '+49 (34298) 158673',
    fax: '+49 (0) 341 123 456 79',
    email: 'info@videowand-leipzig.de',
    web: 'www.videowand-leipzig.de',
    ceo: 'Jan Waschke',
    registrationCourt: 'Amtsgericht Leipzig',
    registrationNumber: 'HRB 12345',
    vatId: 'DE303661894',
    taxNumber: '231/123/12345'
  };
}
